import {
  MONETARY_UNIT,
  RESTRICTION_GROUP,
  RESTRICTION_UNITS,
  MonetaryRestriction,
} from '../../../../../../constants/restriction';

const MONETARY_TYPE_INDEX = RESTRICTION_UNITS.findIndex(
  (restrictionUnit) => restrictionUnit.type === RESTRICTION_GROUP.MONETARY,
);
const monetaryUnit = RESTRICTION_UNITS[
  MONETARY_TYPE_INDEX
] as MonetaryRestriction;
const CLP_RESTRICTION_UNIT_INDEX = monetaryUnit.values.findIndex(
  (restrictionUnitValue) => restrictionUnitValue.value === MONETARY_UNIT.CLP,
);
export const DEFAULT_RESTRICTION_UNIT =
  RESTRICTION_UNITS[MONETARY_TYPE_INDEX].values[CLP_RESTRICTION_UNIT_INDEX]
    .value;
